<template lang="pug">
.revenue-home
    .revenue-home__menu
      el-row(type="flex" justify="center" style="margin-top: 25px")
        el-col(:lg="8" :md="8" :sm="8" :xs="8" style="margin-right: 25px")
          h2 AI Predictive Modeling
          el-row
            el-col(:span="24")
              p % Market Share by Year End 2027 ({{ Math.round(config.marketSharePercentage2027AI*100)/100 * config.totalClients }} of {{ Math.round(config.totalClients) }} Companies): <b>{{ floatToPercent(config.marketSharePercentage2027AI) }}</b>
              el-slider(
                :min="0"
                :step="0.05"
                :max="1"
                color="green"
                tooltip-class="tooltip"
                :format-tooltip="v => `${Math.round(v * 100)}%`"
                v-model='config.marketSharePercentage2027AI'
              )
          el-row
            el-col(:span="24")
              p Monthly Fee per Asset: <b>${{ config.clientFeePerMonthAI.toLocaleString() }}</b>
              el-slider(
                :min="5000"
                :step="5000"
                :max="50000"
                color="green"
                tooltip-class="tooltip"
                :format-tooltip="v => `$${v}`"
                v-model='config.clientFeePerMonthAI'
              )
          el-row
            el-col(:span="24")
              p Onboarding Fee per AI Asset: <b>${{ config.onboardingFeeAI.toLocaleString() }}</b>
              el-slider(
                :min="0"
                :step="5000"
                :max="100000"
                tooltip-class="tooltip"
                :format-tooltip="v => `${v ? v.toLocaleString(): v}`"
                v-model='config.onboardingFeeAI'
                color="dgreen"
              )
          el-row
            el-col(:span="24")
              p Average Number of Assets per AI Client: <b>{{ config.assetPerAIClient.toLocaleString() }}</b>
              el-slider(
                :min="1"
                :step=".2"
                :max="5"
                color="green"
                tooltip-class="tooltip"
                :format-tooltip="v => {v}"
                v-model='config.assetPerAIClient'
              )
        el-col(:lg="8" :md="8" :sm="8" :xs="8" style="margin-right: 25px")
          h2 3D Presentations Only
          el-row
            el-col(:span="24")
              p % Market Share by Year End 2027 ({{ Math.round(config.marketSharePercentage20273D*100)/100 * config.totalClients }} of {{ Math.round(config.totalClients) }} Companies): <b>{{ floatToPercent(config.marketSharePercentage20273D) }}</b>
              el-slider(
                :min="0"
                :step="0.05"
                :max="1"
                tooltip-class="tooltip" :format-tooltip="v => `${Math.round(v * 100)}%`"
                v-model='config.marketSharePercentage20273D'
                color="orange"
              )
          el-row
            el-col(:span="24")
              p Monthly Fee: <b>${{ config.clientFeePerMonth3D.toLocaleString() }}</b>
              el-slider(
                :min="0"
                :step="1000"
                :max="10000"
                tooltip-class="tooltip"
                :format-tooltip="v => `$${v ? v.toLocaleString():v}`"
                v-model='config.clientFeePerMonth3D'
                color="orange"
              )
          el-row
            el-col(:span="24")
              p Onboarding Fee: <b>${{ config.onboardingFee3D.toLocaleString() }}</b>
              el-slider(
                :min="0"
                :step="5000"
                :max="50000"
                tooltip-class="tooltip"
                :format-tooltip="v => `${v ? v.toLocaleString(): v}`"
                v-model='config.onboardingFee3D'
                color="dgreen"
              )
      el-row(type="flex" justify="center")
        el-col(:lg="22" :md="22" :sm="23" :xs="23")
          .flex
            h1(style="margin-bottom: 0; text-align: right; text-color: red;") ARR @ YE 2027: US${{ getTotalYearEndARR(2027) }}
          apexchart(
            width="102%"
            height="400"
            :options="dollarChartOptions"
            :series="revenueChartData"
        )
</template>

<script>
import JSONdata from '../assets/data.json'

export default {
  name: 'revenue',
  data: function () {
    return {
      darkMode: false,
      activeCollapse: [],
      quarters: ['Q1 2024', 'Q2 2024', 'Q3 2024', 'Q4 2024', 'Q1 2025', 'Q2 2025', 'Q3 2025', 'Q4 2025', 'Q1 2026', 'Q2 2026', 'Q3 2026', 'Q4 2026', 'Q1 2027', 'Q2 2027', 'Q3 2027', 'Q4 2027'],
      marks: {
        0: 'Q1 2024',
        4: 'Q1 2025',
        8: 'Q1 2026',
        12: 'Q1 2027'
      },
      config: JSONdata,
      title: 'Revenue Calculator'
    }
  },
  computed: {
    tableColumns () {
      return this.quarters.map((quarter) => `${quarter} ARR`)
    },
    clientsTableData () {
      let data = []
      let clients3D = {}
      let clientsAI = {}

      clients3D[this.quarters[0]] = 155
      clientsAI[this.quarters[1]] = 3
      for (let i = 1; i < this.quarters.length; i++) {
        let dateString = this.quarters[i]
        clients3D[dateString] = this.config.existingClients3D + (
          (this.config.newClientsAvailable * this.config.marketSharePercentage20273D - this.config.existingClients3D) * i / (this.quarters.length - 1))

        clientsAI[dateString] = this.config.existingClientsAI + (
          (this.config.newClientsAvailable * this.config.marketSharePercentage2027AI - this.config.existingClientsAI) * i / (this.quarters.length - 1))
      }

      data.push({
        type: 'AI Predictive Modeling',
        ...clientsAI
      })
      data.push({
        type: '3D Presentations Only',
        ...clients3D
      })

      return data
    },
    revenueTableData () {
      let data = []
      let revenueAI = {}
      let onboardingRevenueAI = {}
      let revenue3D = {}
      let onboardingRevenue3D = {}
      let onboardingRevenue = {}
      let revenue = {}
      let existingClientsAI = JSONdata.existingClientsAI
      let existingClients3D = JSONdata.existingClients3D

      // 2024 Q1 Actuals divided by 3 (per month)
      revenue3D[this.quarters[0]] = 2504241
      revenueAI[this.quarters[0]] = 224000
      onboardingRevenue3D[this.quarters[0]] = 35000
      onboardingRevenueAI[this.quarters[0]] = 35000
      onboardingRevenue[this.quarters[0]] = onboardingRevenue3D[this.quarters[0]] + onboardingRevenueAI[this.quarters[0]]
      revenue[this.quarters[0]] = 2728241

      for (let i = 1; i < this.quarters.length; i++) {
        // Sum estimated revenue from each client type
        let dateString = this.quarters[i]

        revenueAI[dateString] = Math.round(
          this.clientsTableData[0][dateString] * this.config.clientFeePerMonthAI * this.config.assetPerAIClient * 3
        )
        let gainInClientsAI = (this.clientsTableData[0][dateString]) - existingClientsAI
        onboardingRevenueAI[dateString] = Math.round(gainInClientsAI * this.config.onboardingFeeAI * this.config.vrifyPlusPercentage)
        existingClientsAI = (this.clientsTableData[0][dateString])
        console.log(dateString + ' existingClientsAI: ' + existingClientsAI)

        revenue3D[dateString] = Math.round(
          this.clientsTableData[1][dateString] * this.config.clientFeePerMonth3D * 3
        )

        let gainInClients3D = (this.clientsTableData[1][dateString]) - existingClients3D
        onboardingRevenue3D[dateString] = Math.round(gainInClients3D * this.config.onboardingFee3D * this.config.vrifyPlusPercentage)
        existingClients3D = (this.clientsTableData[1][dateString])

        onboardingRevenue[dateString] = onboardingRevenue3D[dateString] + onboardingRevenueAI[dateString]
        revenue[dateString] = (
          revenue3D[dateString] +
          revenueAI[dateString] +
          onboardingRevenue3D[dateString] +
          onboardingRevenueAI[dateString]
        )
      }

      data.push({
        type: 'AI Predictive Modeling Revenue',
        ...revenueAI
      })

      data.push({
        type: 'AI Predictive Modeling Onboarding Revenue',
        ...onboardingRevenueAI
      })

      data.push({
        type: '3D Presentations Only Revenue',
        ...revenue3D
      })

      data.push({
        type: '3D Presentations Only Upfront revenue',
        ...onboardingRevenue3D
      })

      data.push({
        type: 'Revenue',
        ...revenue
      })

      data.push({
        type: 'Onboarding Revenue',
        ...onboardingRevenue
      })
      return data
    },
    dollarChartOptions () {
      // Dollar charts precede each value on y axis with a "$" sign.
      return {
        chart: {
          id: 'revenue-chart',
          stacked: true,
          toolbar: {
            show: false
          }
        },
        colors: ['#a8bfac', '#d7a35e', '#CACFD3', '#cedbb4', '#b8d9eb'],
        xaxis: {
          labels: {
            rotateAlways: false
          },
          categories: this.tableColumns
        },
        yaxis: {
          opposite: true,
          // max: this.yChartMax,
          labels: {
            align: 'right',
            formatter: function (value) {
              return '$ ' + value.toLocaleString()
            }
          }
        },
        stroke: {
          show: true,
          width: [0, 0, 0, 0, 0]
        },
        dataLabels: {
          enabled: false
        }
      }
    },
    revenueChartData () {
      return [
        {
          name: 'AI Predictive Modeling',
          type: 'bar',
          data: Object.entries(this.revenueTableData[0]).slice(1).map(([key, value]) => {
            return value * 3 || 0
          })
        },
        {
          name: '3D Presentations Only',
          type: 'bar',
          data: Object.entries(this.revenueTableData[2]).slice(1).map(([key, value]) => {
            return value * 3 || 0
          })
        },
        {
          name: 'Onboarding/Update Revenue',
          type: 'bar',
          data: Object.entries(this.revenueTableData[5]).slice(1).map(([key, value]) => {
            return value || 0
          })
        }
      ]
    },
    yChartMax () {
      return Math.max(...Object.values(this.revenueTableData[0]).slice(1)) * 1.05
    },
    welcomeText () {
      let today = new Date()
      let hour = today.getHours()
      if (hour > 3 && hour < 12) return 'morning'
      if (hour >= 12 && hour < 18) return 'afternoon'
      return 'evening'
    }
  },
  methods: {
    getTotalYearEndARR (year) {
      const revenue = this.revenueTableData[0]['Q4 ' + year] + this.revenueTableData[1]['Q4 ' + year] + this.revenueTableData[2]['Q4 ' + year] + this.revenueTableData[3]['Q4 ' + year]
      const annualRevenue = Math.floor(revenue / 3 * 12)
      return annualRevenue.toLocaleString()
    },
    floatToPercent (value) {
      return `${Math.round(value * 100)}%`
    }
  },
  watch: {
    darkMode (activated) {
      // Fired when dark mode switch is clicked
      if (activated) {
        document.documentElement.style.filter = 'invert(1)'
        document.documentElement.style.backgroundColor = 'black'
        document.getElementsByClassName('el-popover')[0].style.borderColor = '#b2b3b5'
      } else {
        document.documentElement.style.filter = 'invert(0)'
        document.documentElement.style.backgroundColor = 'white'
        document.getElementsByClassName('el-popover')[0].style.borderColor = '#fefefe'
      }
    }
  }
}
</script>

<style scoped>
.tooltip {
  font-family: sans-serif;
}

.darkModeSwitch {
  position: fixed !important;
  top: 17px;
  right: 22px;
  z-index: 13;
}

.revenue-home {
  padding: 10px;
  background: white;
}

.revenue-home h1 {
  font-size: 40px;
  margin-bottom: 0;
}

.revenue-home h2 {
  font-size: 21px;
  font-weight: bold;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
}

.revenue-home h4 {
  color: #555;
  font-weight: 100;
  font-size: 21px;
  margin-top: 6px;
}

.revenue-home__menu {
  font-size: 13px;
  line-height: 16px;
  width: 100%;
  background-color: white;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.03);
  z-index: 12;
}

.revenue-home__menu p,
.revenue-home__menu b {
  color: black;
  margin: 0;
}

.revenue-home__menu b {
  float: right;
}

.revenue-home .footer p {
  font-size: 13px;
  margin: 50px auto;
}

.revenue-home .el-tag {
  font-weight: bold;
  border-color: white;
  margin-left: 30px;
  margin-right: 30px;
  font-size: 15px;
  padding-top: 20px;
  padding-bottom: 0px;
  padding-right: 1% !important;
  padding-left: 1% !important;
  vertical-align: middle;
  display: block;
  height: 30px;
  line-height: 14px;
}

@media screen and (max-width: 1366px) {
  .tooltip {
    display: none;
  }
}
</style>
